'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarUserLightIcon = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var AvatarUserLightIcon = function AvatarUserLightIcon(_ref) {
  var _ref$background = _ref.background,
      background = _ref$background === undefined ? '#edeff2' : _ref$background,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#B7B9BC' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 24 : _ref$width,
      props = _objectWithoutProperties(_ref, ['background', 'color', 'height', 'width']);

  return _react2.default.createElement('svg', _extends({
    id: 'Layer_1',
    viewBox: '0 0 24 24',
    fill: color,
    height: height,
    width: width
  }, props), _react2.default.createElement('g', {
    id: 'Layer_1_1_'
  }, _react2.default.createElement('circle', {
    cx: 12,
    cy: 12,
    r: 12,
    fill: background
  }), _react2.default.createElement('path', {
    className: 'st1',
    d: 'M17.4 19c-.5 0-.9-.4-.9-.9v-1.4c0-1-.8-1.8-1.8-1.8H9.3c-1 0-1.8.8-1.8 1.8v1.4c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-1.4c0-2 1.6-3.6 3.6-3.6h5.4c2 0 3.6 1.6 3.6 3.6v1.4c0 .4-.4.8-.9.9zM12 12.2c-2 0-3.6-1.6-3.6-3.6S10 5 12 5s3.6 1.6 3.6 3.6-1.6 3.6-3.6 3.6zm0-5.4c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8S13 6.8 12 6.8z'
  })));
};

exports.AvatarUserLightIcon = AvatarUserLightIcon;